export default "__VITE_ASSET__15592fd8__"